export enum StartBreakResponseCode {
  Success,
  BreakAlreadyExists,
  AlreadyOnBreak,
  ErrorInsertingBreak,
  UserNotAtSpecifiedLocation,
  EventDoesNotMatchCurrentUser,
  InvalidUnscheduledBreak,
}
